import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appCapitalizeWords]'
})
export class CapitalizeWordsDirective implements AfterViewInit{

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.capitalizeText();
  }

  private capitalizeText(): void {
    const element = this.el.nativeElement;
    element.textContent = element.textContent
      .toLowerCase() // Convert all text to lowercase
      .replace(/\b\w/g, (char:any) => char.toUpperCase()); // Capitalize first letter of each word
  }
}
